// facility online doctors modals

import { createApp } from 'vue/dist/vue.esm-bundler'
import axios from 'axios';
import { load as recaptchaLoad } from 'recaptcha-v3';

const onlineDoctorsAppWrapper = '#FacilityOnlineDoctorsModals';
const onlineDoctorsModals = document.querySelector(onlineDoctorsAppWrapper);
const siteKey = EUCUtils.getRecaptchaSiteKey();

if ( onlineDoctorsModals )
{
    createApp({
        data(){
          return {
              clinicID: $(onlineDoctorsAppWrapper).data('clinic-id') || 0,
              PageId: $(onlineDoctorsAppWrapper).data('page-id') || 0,
              ChannelId: $(onlineDoctorsAppWrapper).data('channel-id') || 0,
              // !!! if you are changing values below, change RESET values in mounted() as well
              modals: {
                  activation: {
                      isSending: false,
                      error: {
                          showError: false,
                          message: ''
                      },
                      success: {
                        showSuccess: false
                      },
                      name: $('#PraktikLeadgenName').data('value') ? $('#PraktikLeadgenName').data('value') : '',
                      mail: $('#PraktikLeadgenEmail').data('value') ? $('#PraktikLeadgenEmail').data('value') : '',
                      tel: $('#PraktikLeadgenPhone').data('value') ? $('#PraktikLeadgenPhone').data('value') : '',
                      birthDate: $('#PraktikLeadgenBirthDate').data('value') ? $('#PraktikLeadgenBirthDate').data('value') : ''
                  },
                  agreements: {
                      isSending: false,
                      error: {
                          showError: false,
                          message: ''
                      },
                      conditions: $(onlineDoctorsAppWrapper).data('agreements-conditions') === "True" ? true : false,
                      equipment: $(onlineDoctorsAppWrapper).data('agreements-equipment') === "True" ? true : false,
                      gdpr: $(onlineDoctorsAppWrapper).data('agreements-gdpr') === "True" ? true : false
                  }
              }
          }
      },
      mounted(){
        // RESET forms when modal is closed
        $('#callActivation').on('hidden.bs.modal', () => {
          this.modals.activation = {
            isSending: false,
            error: {
                showError: false,
                message: ''
            },
            success: {
              showSuccess: false
            },
            name: $('#PraktikLeadgenName').data('value') ? $('#PraktikLeadgenName').data('value') : '',
            mail: $('#PraktikLeadgenEmail').data('value') ? $('#PraktikLeadgenEmail').data('value') : '',
            tel: $('#PraktikLeadgenPhone').data('value') ? $('#PraktikLeadgenPhone').data('value') : '',
            birthDate: $('#PraktikLeadgenBirthDate').data('value') ? $('#PraktikLeadgenBirthDate').data('value') : ''
          }
        });
        $('#agreements').on('hidden.bs.modal', () => {
          this.modals.agreements = {
            isSending: false,
            error: {
                showError: false,
                message: ''
            },
            conditions: $(onlineDoctorsAppWrapper).data('agreements-conditions') === "True" ? true : false,
            equipment: $(onlineDoctorsAppWrapper).data('agreements-equipment') === "True" ? true : false,
            gdpr: $(onlineDoctorsAppWrapper).data('agreements-gdpr') === "True" ? true : false
          }
        });
      },
      methods: {
          async sendActivation(){

              this.modals.activation.isSending = true;

              let data = this.modals.activation;

              // handle reCaptcha
              let reCaptchaResponse = '';

              // if we have site key
              if ( siteKey.length )
              {
                // await captcha load
                const recaptcha = await recaptchaLoad(siteKey);

                // get token
                reCaptchaResponse = await recaptcha.execute('facility_online_doctors_activation');
              }


              axios.post(`${API_HOST}/GPOnline/LeadGenForm`, {
                  clinicId: this.clinicID,
                  PageId: this.PageId,
                  ChannelId: this.ChannelId,
                  name: data.name,
                  email: data.mail,
                  phone: data.tel,
                  birthDate: data.birthDate,
                  reCaptchaResponse: reCaptchaResponse
                }).then(response => {
      
                  console.log(response);
                  this.modals.activation.error.showError = false;
                  this.modals.activation.success.showSuccess = true;
      
                }).catch(err => {
                  console.log(err);

                  if ( err.response && err.response.data.Message )
                  {
                    // show error message from backend, if any
                    this.modals.activation.error.message = err.response.data.Message;
                  }

                  this.modals.activation.success.showSuccess = false;
                  this.modals.activation.error.showError = true;

                }).finally(() => {
                  this.modals.activation.isSending = false;
                  
                  // RESET values in fields
                  this.modals.activation.name = $('#PraktikLeadgenName').data('value') ? $('#PraktikLeadgenName').data('value') : '';
                  this.modals.activation.mail = $('#PraktikLeadgenEmail').data('value') ? $('#PraktikLeadgenEmail').data('value') : '';
                  this.modals.activation.tel = $('#PraktikLeadgenPhone').data('value') ? $('#PraktikLeadgenPhone').data('value') : '';
                  this.modals.activation.birthDate = $('#PraktikLeadgenBirthDate').data('value') ? $('#PraktikLeadgenBirthDate').data('value') : '';
                });

          },
          async sendAgreements(){

              this.modals.agreements.isSending = true;

              let data = this.modals.agreements;


              // handle reCaptcha
              let reCaptchaResponse = '';

              // if we have site key
              if ( siteKey.length )
              {
                // await captcha load
                const recaptcha = await recaptchaLoad(siteKey);

                // get token
                reCaptchaResponse = await recaptcha.execute('facility_online_doctors_agreements');
              }


              axios.post(`${API_HOST}/GPOnline/AgreementForm`, {
                  clinicId: this.clinicID,
                  PageId: this.PageId,
                  ChannelId: this.ChannelId,
                  checkConditions: data.conditions,
                  checkTechnicalEquipment: data.equipment,
                  checkGDPR: data.gdpr,
                  reCaptchaResponse: reCaptchaResponse
                }).then(response => {
      
                  console.log(response);

                  // if we got a url to go to, redirect
                  if ( response.data.RedirectUrl )
                  {
                    window.location.href = response.data.RedirectUrl;
                  }
      
                }).catch(err => {
                  console.log(err);

                  if ( err.response && err.response.data.Message )
                  {
                    // show error message from backend, if any
                    this.modals.agreements.error.message = err.response.data.Message;
                  }

                  this.modals.agreements.error.showError = true;
                }).finally(() => {
                  this.modals.agreements.isSending = false;

                  // RESET values in fields
                  this.modals.agreements.conditions = $(onlineDoctorsAppWrapper).data('agreements-conditions') === "True" ? true : false;
                  this.modals.agreements.equipment = $(onlineDoctorsAppWrapper).data('agreements-equipment') === "True" ? true : false;
                  this.modals.agreements.gdpr = $(onlineDoctorsAppWrapper).data('agreements-gdpr') === "True" ? true : false;
                });

          }
      }
    }).mount(onlineDoctorsAppWrapper);
}